import React from 'react'

export default class PreCode extends React.Component {
  render() {
    return (
      <pre>
        <code
          className={this.props.className}
          style={this.props.style}
        >
          {JSON.stringify(this.props.value,null,2)}
        </code>
      </pre>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PreCode.js